import { relate } from '/app/utils/relationships';

export default requester => {
    return {
        /**
         * Get content
         *
         * @return {object}
         */
        find(slug, handle) {
            return requester.get(`/content/authors/${handle}/contents/${slug}`).then(relate(
                [ [item => `user:${item.owner}`, 'author'] ]
            ));
        },

        /**
         * List all contents for an author
         *
         * @param {string} handle
         * @return {object}
         */
        list(handle) {
            return requester.get(`/content/authors/${handle}/contents`).then(relate(
                [ [item => `user:${item.owner}`, 'author'] ]
            ));
        },

        /**
         * Update content
         *
         * @param {string} id
         * @param {object} payload
         * @return {object}
         */
        update(id, handle, payload) {
            return requester.put(`/content/authors/${handle}/contents/${id}`, payload);
        },

        /**
         * Delete content
         *
         * @param {string} id
         * @param {string} handle
         * @return {object}
         */
        delete(id, handle) {
            return requester.delete(`/content/authors/${handle}/contents/${id}`);
        },

        /**
         * Create or update content
         * @return {object}
         */
        save(payload) {
            return requester.post(`/content/contents`, payload);
        },

        /**
         * Get suggestions
         * 
         * @return {object}
         */
        suggestions() {
            return requester.get(`/content/suggestions`);
        },

        /**
         * View content
         * 
         * @param {string} contentType
         * @param {string} contentId
         * @return {object}
         */
        view(payload) {
            return requester.post(`/content/views`, payload);
        },
    };
}
